import { CoreService } from 'src/app/core/services/core.service';
import { DatePipePipe } from './../../../shared/pipes/date-pipe.pipe';
import {
  CREATE_TRAINING,
  GET_TRAININGS,
  UPDATE_TRAINING,
  CREATE_AFFILIATION,
  UPDATE_AFFILIATION,
  GET_AFFILIATIONS,
  UPLOAD_BULK_USERS,
  GET_FILE_UPLOAD,
  CREATE_FILE_UPLOAD,
  UPDATE_FILE_UPLOAD,
  GET_USER_FILE_DOWNLOAD, GET_USERS_DASHBOARD
} from './../../../shared/constants/user-api-constants';
import {
  ACTIVE,
  IN_ACTIVE,
  NAME,
  LOGIN,
  STATUS,
  ROLE_TYPE,
  ACCESS_LEVEL,
  UPDATED_ON,
} from './../../../shared/constants/constant';
import {
  GET_USERS,
  CREATE_UPDATE_USER,
  GET_USER,
} from '../../../shared/constants/user-api-constants';
import { map } from 'rxjs/operators';
import { TableGridHeader } from './../../../shared/components/table-grid/table-grid.model';
import { ApiService } from './../../../core/services/api.service';
import {
  UserDetail,
  UserDetails,
  UserTrainingDetails,
  UserAffiliationDetails,
  UserFileUploadDetails,
} from './../../../shared/models/userDetail.model';
import { GraphApiService } from './../../../core/services/graph-api.service';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DateValidatorWithFutureDate, DateValidator } from '../../../shared/validators/dateValidator';
import { checkForNull } from 'src/app/shared/utilities/util';
import { PhoneNumberValidator, SymbolValidator, TextValidator } from '../../../shared/validators/textPatternValidator';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root',
})
export class ManageUsersService {
  public userList: UserDetails[];
  public updateUserProfileUpdateStr = new Subject();
  public updateTabs = new Subject();

  constructor(
    private graphApiService: GraphApiService,
    private apiService: ApiService,
    private coreService: CoreService
  ) { }

  /**
   *
   *
   * @param {*} user
   * @return {*}  {Observable<any>}
   * @memberof ManageUsersService
   * @description used to create user in BRRD application
   */
  public createUser(user): Observable<any> {
    return this.apiService.postData(CREATE_UPDATE_USER, user);
  }

  /**
   *
   *
   * @param {*} trainingData
   * @param {string} [id]
   * @return {*}  {Observable<any>}
   * @memberof ManageUsersService
   * @description used to create training data in DB
   */
  public postTrainingData(trainingData, id?: string): Observable<any> {
    return this.apiService.postData(CREATE_TRAINING, trainingData);
  }

  /**
   *
   *
   * @param {*} trainingData
   * @param {string} id
   * @return {*}  {Observable<any>}
   * @memberof ManageUsersService
   * @description used to update training data in DB
   */
  public updateTrainingData(trainingData, id: string): Observable<any> {
    return this.apiService.postData(`${UPDATE_TRAINING}${id}`, trainingData);
  }

  /**
   *
   *
   * @param {number} loginID
   * @return {*}  {Observable<any>}
   * @memberof ManageUsersService
   * @description used to get training tab data
   */
  public getTrainingData(loginID: number): Observable<any> {
    return this.apiService.fetchData(`${GET_TRAININGS}${loginID}`);
  }

  /**
   *
   *
   * @param {*} affiliationData
   * @param {string} [id]
   * @return {*}  {Observable<any>}
   * @memberof ManageUsersService
   * @description used to create affiliation data in DB
   */
  public postAffiliationData(affiliationData, id?: string): Observable<any> {
    return this.apiService.postData(CREATE_AFFILIATION, affiliationData);
  }

  /**
   *
   *
   * @param {*} affiliationData
   * @param {string} id
   * @return {*}  {Observable<any>}
   * @memberof ManageUsersService
   * @description used to update affiliation data
   */
  public updateAffiliationData(affiliationData, id: string): Observable<any> {
    return this.apiService.postData(
      `${UPDATE_AFFILIATION}${id}`,
      affiliationData
    );
  }

  /**
   *
   *
   * @param {number} loginID
   * @return {*}  {Observable<any>}
   * @memberof ManageUsersService
   * @description used to get affiliation data
   */
  public getAffiliationData(loginID: number): Observable<any> {
    return this.apiService.fetchData(`${GET_AFFILIATIONS}${loginID}`).pipe(
      map((affiliations: UserAffiliationDetails[]) => {
        affiliations.forEach((affiliation: UserAffiliationDetails) => {
          affiliation.professionalBodyCodeName = this.coreService.getDropdownValueByID(
            affiliation.professionalBodyCode
          );
          affiliation.membershipCategoryCodeName = this.coreService.getDropdownValueByID(
            affiliation.membershipCategoryCode
          );
          affiliation.isPrimaryName = affiliation.isPrimary === '1' ? 'Yes' : 'No';
        });
        return affiliations;
      })
    );
  }

  /**
   *
   *
   * @param {(number | string)} loginID
   * @return {*}  {Observable<any>}
   * @memberof ManageUsersService
   * @description used to get users file data
   */
  public getUserFilesData(loginID: number | string): Observable<any> {
    return this.apiService.fetchData(`${GET_FILE_UPLOAD}${loginID}`).pipe(
      map((documentFiles: UserFileUploadDetails[]) => {
        documentFiles.forEach((documentFile: UserFileUploadDetails) => {
          documentFile.fileTypeCodeName = this.coreService.getDropdownValueByID(
            documentFile.fileTypeCode
          );
        });
        return documentFiles;
      })
    );
  }

  /**
   *
   *
   * @param {*} fileUploadFormData
   * @return {*}  {Observable<any>}
   * @memberof ManageUsersService
   */
  public postUserFilesData(fileUploadFormData): Observable<any> {
    return this.apiService.postData(CREATE_FILE_UPLOAD, fileUploadFormData);
  }

  /**
   *
   *
   * @param {*} fileUploadFormData
   * @param {string} id
   * @return {*}  {Observable<any>}
   * @memberof ManageUsersService
   * @description used to update uploaded file data
   */
  public updateUserFilesData(fileUploadFormData, id: string): Observable<any> {
    return this.apiService.postData(
      `${UPDATE_FILE_UPLOAD}${id}`,
      fileUploadFormData
    );
  }

  /**
   *
   *
   * @param {string} id
   * @return {*}  {Observable<any>}
   * @memberof ManageUsersService
   * @description function used to download uploaded files
   */
  public getUserFileDownload(id: string): Observable<any> {
    return this.apiService.postData(`${GET_USER_FILE_DOWNLOAD}${id}`, {});
  }

  /**
   *
   *
   * @param {UserDetail} [user]
   * @return {*}  {FormGroup}
   * @memberof ManageUsersService
   * @description form group of upload tab
   */
  public getUserFileFormControls(user?: UserDetail): FormGroup {
    return new FormGroup({
      fileTypeCode: new FormControl(null, [Validators.required]),
      file: new FormControl(null, [Validators.required]),
      isPrimary: new FormControl(null),
      isActive: new FormControl('1'),
    });
  }
  
  /**
   *
   *
   * @return {*}  {Observable<any>}
   * @memberof ManageUsersService
   * @description getting all users exist in BRRD application
   */
  public getAllUsers(): Observable<any> {
    return this.apiService.fetchData(GET_USERS_DASHBOARD).pipe(
      map((users: UserDetails[]) => {
        users.forEach((user) => {
          this.updateUserData(user);
        });
        users = _.orderBy(users, ['firstName', 'isActiveStr'], ['asc', 'asc']);
        this.userList = users;
        sessionStorage.setItem('ALL_USERS', JSON.stringify(users));
        return users;
      })
    );
  }

  /**
   *
   *
   * @return {*}  {UserDetails[]}
   * @memberof ManageUsersService
   * @description used to get all exist users 
   */
  public getAllExistingUsers(): UserDetails[] {
    return this.userList;
  }

  /**
   *
   *
   * @param {number} loginID
   * @return {*}  {Observable<any>}
   * @memberof ManageUsersService
   * @description used to get user details using login id
   */
  public getUser(loginID: number): Observable<any> {
    return this.apiService
      .fetchData(`${GET_USER}${loginID}`)
      .pipe(
        map((users: UserDetails[]) => {
          users.forEach((user) => {
            this.updateUserData(user);
          });
          return users[0];
        })
      );
  }

  /**
   *
   *
   * @private
   * @param {UserDetails} user
   * @memberof ManageUsersService
   * @description used user details by manupulating ids with name for dropdown values
   */
  private updateUserData(user: UserDetails): void {
    user.roleTypeName = this.coreService.getDropdownValueByID(
      user.roleTypeCode
    );
    user.nodeName = this.coreService.getDropdownValueByID(user.nodeID, true);
    user.accessTypeName = this.coreService.getDropdownValueByID(user.accessTypeCode);
    user.isActiveStr = user.isActive === '1' ? ACTIVE : IN_ACTIVE;
    user.displayName = `${user.firstName} ${user.lastName}`;
    user.updatedOn = user.updatedOn.split('T')[0];
    checkForNull(user);
  }

  /**
   *
   *
   * @param {*} file
   * @return {*}  {Observable<any>}
   * @memberof ManageUsersService
   * @description funtion used to upload file to generate users in bulk by using excel file
   */
  public uploadUsersFile(file): Observable<any> {
    return this.apiService.postData(UPLOAD_BULK_USERS, file);
  }

  /**
   *
   *
   * @return {*}  {TableGridHeader[]}
   * @memberof ManageUsersService
   * @description headers of users table
   */
  getUserTableHeader(): TableGridHeader[] {
    return [
      { name: NAME, key: 'displayName', sortType: 'string', type: 'searchName' },
      { name: LOGIN, key: 'loginName', sortType: 'string', type: 'searchName' },
      { name: STATUS, key: 'isActiveStr', sortType: 'string', sort: 'none' },
      { name: ROLE_TYPE, key: 'roleTypeName', sortType: 'string' },
      { name: ACCESS_LEVEL, key: 'accessTypeName', sortType: 'string', type: 'searchName' },
      { name: UPDATED_ON, key: 'updatedOn', sortType: 'date', type: 'date' },
      { name: '', key: '', type: 'edit-button' },
    ];
  }

  /**
   *
   *
   * @return {*}  {TableGridHeader[]}
   * @memberof ManageUsersService
   * @description headers of user -> training tab
   */
  getUserTrainingHeaders(): TableGridHeader[] {
    return [
      {
        name: 'Date of completion',
        key: 'trainingDate',
        sortType: 'date',
        type: 'date',
      },
      { name: 'Training Name', key: 'trainingName', sortType: 'string', type: 'string' },
      { name: '', key: '', type: 'edit-delete-button' },
    ];
  }
  /**
   *
   *
   * @return {*}  {TableGridHeader[]}
   * @memberof ManageUsersService
   * @description headers of user -> upload tab
   */
  getUserFileUploadHeaders(): TableGridHeader[] {
    return [
      {
        name: 'Document',
        key: 'fileTypeCodeName',
        sortType: 'string',
        type: 'string',
      },
      { name: 'Document upload', key: 'fileName', sortType: 'string', type: 'string' },
      { name: 'Date', key: 'updatedOn', sortType: 'date', type: 'date' },
      { name: '', key: '', type: 'delete-download-button' },
    ];
  }
  /**
   *
   *
   * @return {*}  {TableGridHeader[]}
   * @memberof ManageUsersService
   * @description headers of user -> affiliation tab
   */
  getUserAffiliationHeaders(): TableGridHeader[] {
    return [
      {
        name: 'Primary',
        key: 'isPrimaryName',
        sortType: 'string',
        type: 'string'
      },
      {
        name: 'Professional body',
        key: 'professionalBodyCodeName',
        sortType: 'string',
      },
      {
        name: 'Membership category',
        key: 'membershipCategoryCodeName',
        sortType: 'string',
      },
      { name: 'Membership number', key: 'membershipNumber', sortType: 'number' },
      {
        name: 'Membership expiry date',
        key: 'expiryDate',
        sortType: 'date',
        type: 'date',
      },
      { name: '', key: '', type: 'edit-delete-button' },
    ];
  }

  /**
   *
   *
   * @param {UserDetail} [user]
   * @return {*}  {FormGroup}
   * @memberof ManageUsersService
   * @description form group of user -> bulk user upload
   */
  public getUsersUploadFormControls(user?: UserDetail): FormGroup {
    return new FormGroup({
      usersFile: new FormControl(null, [Validators.required]),
    });
  }

  /**
   *
   *
   * @param {UserAffiliationDetails} [affiliationData]
   * @return {*}  {FormGroup}
   * @memberof ManageUsersService
   * @description form group of affiliation form
   */
  public getUserAffiliationFormControls(
    affiliationData?: UserAffiliationDetails
  ): FormGroup {
    return new FormGroup({
      id: new FormControl(affiliationData ? affiliationData.id : null),
      affiliationCode: new FormControl(
        affiliationData ? affiliationData.affiliationCode : null
      ),
      professionalBodyCode: new FormControl(
        affiliationData ? affiliationData.professionalBodyCode : null,
        [Validators.required]
      ),
      membershipCategoryCode: new FormControl(
        affiliationData ? affiliationData.membershipCategoryCode : null,
        [Validators.required]
      ),
      membershipNumber: new FormControl(
        affiliationData ? affiliationData.membershipNumber : null,
        [Validators.required, TextValidator(50), SymbolValidator()]
      ),
      expiryDate: new FormControl(
        affiliationData
          ? new DatePipePipe().transform(affiliationData.expiryDate)
          : null,
        [Validators.required, DateValidator()]
      ),
      isPrimary: new FormControl(
        affiliationData ? affiliationData.isPrimary : null,
        [Validators.required]
      ),
      isActive: new FormControl(
        affiliationData ? affiliationData.isActive : null
      ),
    });
  }

  /**
   *
   *
   * @param {UserTrainingDetails} [trainingData]
   * @return {*}  {FormGroup}
   * @memberof ManageUsersService
   * @description form group of user training form 
   */
  public getUserTrainingFormControls(
    trainingData?: UserTrainingDetails
  ): FormGroup {
    return new FormGroup({
      id: new FormControl(trainingData ? trainingData.id : null),
      trainingName: new FormControl(
        trainingData ? trainingData.trainingName : null, [Validators.required, TextValidator(50), SymbolValidator()]
      ),
      trainingDate: new FormControl(
        trainingData
          ? new DatePipePipe().transform(trainingData.trainingDate)
          : null,
        [Validators.required, DateValidatorWithFutureDate()]
      ),
      isMandatory: new FormControl(
        trainingData ? trainingData.isMandatory : null
      ),
      isActive: new FormControl(trainingData ? trainingData.isActive : null),
    });
  }

  /**
   *
   *
   * @param {(UserDetail & UserDetails)} [user]
   * @return {*}  {FormGroup}
   * @memberof ManageUsersService
   * @description form group of user prifile
   */
  public getUserProfileFormControls(
    user?: UserDetail & UserDetails
  ): FormGroup {
    const guid = user.id || user.guid;
    const workPhoneNumber = user.businessPhones
      ? user.businessPhones[0]
      : user.workPhoneNumber
        ? user.workPhoneNumber
        : null;
    const loginName = user.bhpLoginName || user.loginName;
    const firstName = user.givenName || user.firstName;
    const firstNameObj = firstName ? { value: firstName, disabled: true } : null;
    const middleName = user.middleName ? user.middleName : null;
    const lastName = user.surname || user.lastName;
    const lastNameObj = lastName ? { value: lastName, disabled: true } : null;
    const preferredName = user.givenName || user.preferredName;
    const adEmailID = user.userPrincipalName || user.adEmailID;
    const notificationEmailID = user.notificationEmailID
      ? user.notificationEmailID
      : adEmailID ? adEmailID : null;
    const currentPosition = user.jobTitle || user.currentPosition;
    const currentPositionObj = currentPosition ? { value: currentPosition, disabled: true } : null;
    const nodeID = user.nodeID ? user.nodeID : null;
    const accessTypeCode = user.accessTypeCode ? user.accessTypeCode : null;
    const roleTypeCode = user.roleTypeCode ? user.roleTypeCode : null;
    const preDominantRoleTypeCode = user.preDominantRoleTypeCode
      ? user.preDominantRoleTypeCode : null;
    const company = user.company ? user.company : 'bhp';
    const firstLangCode = user.firstLangCode ? user.firstLangCode : null;
    const firstLangFluencyCode = user.firstLangFluencyCode
      ? user.firstLangFluencyCode
      : null;
    const mobileNumber = user.mobilePhone
      ? user.mobilePhone
      : user.mobileNumber
        ? user.mobileNumber
        : null;
    const mobileNumberObj = mobileNumber ? { value: mobileNumber, disabled: true } : null;
    const genderCode = user.genderCode ? user.genderCode : null;
    const officeLocationObj = user.officeLocation ? { value: user.officeLocation, disabled: false } : null;
    return new FormGroup({
      guid: new FormControl(guid),
      loginName: new FormControl({ value: loginName, disabled: true },
        Validators.required),
      firstName: new FormControl(firstNameObj, [
        Validators.required,
      ]),
      middleName: new FormControl(middleName),
      lastName: new FormControl(lastNameObj, Validators.required),
      preferredName: new FormControl(preferredName, [Validators.required]),
      notificationEmailID: new FormControl(notificationEmailID, [
        Validators.required,
        Validators.email,
      ]),
      adEmailID: new FormControl({ value: adEmailID, disabled: true }, [
        Validators.required,
        Validators.email,
      ]),
      currentPosition: new FormControl(
        currentPositionObj,
        [Validators.required, SymbolValidator(), TextValidator(50)]
      ),
      nodeID: new FormControl(nodeID),
      accessTypeCode: new FormControl(accessTypeCode),
      roleTypeCode: new FormControl(roleTypeCode, Validators.required),
      preDominantRoleTypeCode: new FormControl(preDominantRoleTypeCode),
      company: new FormControl(company, Validators.required),
      firstLangCode: new FormControl(firstLangCode, Validators.required),
      firstLangFluencyCode: new FormControl(
        firstLangFluencyCode,
        Validators.required
      ),
      secondLangCode: new FormControl(
        user.secondLangCode,
      ),
      secondLangFluencyCode: new FormControl(
        user.secondLangFluencyCode,
      ),
      genderCode: new FormControl(genderCode, [Validators.required]),
      totalExperience: new FormControl(0),
      relevantExperience: new FormControl(0),
      workPhoneNumber: new FormControl(workPhoneNumber, [
        PhoneNumberValidator(),
      ]),
      mobileNumber: new FormControl(
        mobileNumberObj,
        [Validators.required, PhoneNumberValidator()]
      ),
      notes: new FormControl(user.notes),
      isActive: new FormControl(user.isActive === '1' || !user.isActive ? 'Yes' : 'No'),
      bhpLogin: new FormControl(
        { value: loginName, disabled: true },
        Validators.required
      ),
      sameEmail: new FormControl(
        adEmailID &&
          notificationEmailID &&
          adEmailID === notificationEmailID
          ? true
          : false
      ),
      officeLocation: new FormControl(
        officeLocationObj
      ),
      isReturningCP: new FormControl(user.isReturningCP === '1' ? 'Yes' : 'No'),
      userTypeCode: new FormControl(
        user.userTypeCode ? user.userTypeCode : null, [Validators.required]
      ),
      managerLoginID: new FormControl(user.managerLoginID)
    });
  }

  /**
   *
   *
   * @param {string} givenName
   * @return {*}  {Observable<UserDetail[]>}
   * @memberof ManageUsersService
   * @description used to get users details by name
   */
  public getGraphUsersbyGivenName(givenName: string): Observable<UserDetail[]> {
    return this.graphApiService.getUsers(givenName);
  }
}
